import React from "react";

import VerifyAccountForm from "./Components/FormControl/VerifyAccountForm";

import AuthLayout from "@/Components/Layouts/Native/AuthLayout";

function VerifyAccountScreen(): React.JSX.Element {
  return (
    <AuthLayout>
      <VerifyAccountForm />
    </AuthLayout>
  );
}

export default VerifyAccountScreen;
